import { Card } from "@/components/ui/card";

const PALETTE = ["#0b1a3a", "#1d4ed8", "#0f766e", "#7c3aed", "#b45309", "#be123c", "#0e7490", "#4d7c0f", "#9d174d", "#374151"];
const pick = (s = "") => PALETTE[[...s].reduce((h, ch) => (h * 31 + ch.charCodeAt(0)) >>> 0, 7) % PALETTE.length];

export function StatCard({ label, value, sub, icon: Icon, testid, color }) {
  const bg = color || pick(label);
  return (
    <Card data-testid={testid} className="p-3 sm:p-5 relative overflow-hidden min-w-0 border-0 text-white shadow-md" style={{ background: bg }}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-[10px] sm:text-xs uppercase tracking-wider text-white/70 font-medium truncate">{label}</p>
          <p className="mt-1 sm:mt-2 text-lg sm:text-2xl font-bold font-mono-num tracking-tight truncate">{value}</p>
          {sub && <p className="mt-1 text-xs text-white/70 truncate">{sub}</p>}
        </div>
        {Icon && (
          <span className="hidden sm:grid place-items-center w-10 h-10 rounded-lg bg-white/15 shrink-0 text-white">
            <Icon className="w-5 h-5" />
          </span>
        )}
      </div>
    </Card>
  );
}
